import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Download, Trash2, CheckCircle } from 'lucide-react'
import type { Plantilla, PlantillaTwilio } from '../types'

interface PlantillaCardProps {
  plantilla: Plantilla | PlantillaTwilio
  type: 'local' | 'twilio'
  onImportar?: (sid: string) => void
  onEliminar?: (id: number) => void
}

export function PlantillaCard({ plantilla, type, onImportar, onEliminar }: PlantillaCardProps) {
  if (type === 'twilio') {
    const p = plantilla as PlantillaTwilio
    return (
      <Card className="mb-3 border border-gray-300 dark:border-gray-700">
        <CardContent className="pt-6">
          <div className="flex justify-between items-start gap-4">
            <div className="flex-1">
              <h6 className="font-semibold mb-1">{p.friendly_name}</h6>
              <p className="text-xs text-muted-foreground mb-2">{p.sid}</p>
              <p className="text-sm mb-2 whitespace-pre-wrap">{p.contenido}</p>
              {p.variables && p.variables.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-2">
                  {p.variables.map((v) => (
                    <Badge key={v} className="badge-gradient hover:opacity-90 text-xs">
                      {`{{${v}}}`}
                    </Badge>
                  ))}
                </div>
              )}
            </div>
            <div className="flex-shrink-0">
              {p.existe_local ? (
                <Badge className="badge-gradient hover:opacity-90">
                  <CheckCircle className="h-3 w-3 mr-1" />
                  Importada
                </Badge>
              ) : (
                <Button
                  size="sm"
                  onClick={() => onImportar?.(p.sid)}
                  className="bg-teal-800 hover:bg-teal-900 text-white"
                >
                  <Download className="h-3 w-3 mr-1" />
                  Importar
                </Button>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    )
  }

  // Local plantilla
  const p = plantilla as Plantilla
  return (
    <Card className="mb-3 border border-gray-300 dark:border-gray-700">
      <CardContent className="pt-6">
        <div className="flex justify-between items-start gap-4">
          <div className="flex-1">
            <h6 className="font-semibold mb-1">{p.nombre}</h6>
            <p className="text-xs text-muted-foreground mb-2">{p.content_sid}</p>
            <div className="flex gap-2 mt-2">
              {p.is_active ? (
                <Badge className="badge-gradient hover:opacity-90">Activa</Badge>
              ) : (
                <Badge variant="outline" className="text-gray-400 border-gray-400">Inactiva</Badge>
              )}
              <Badge className="badge-gradient hover:opacity-90">
                {p.total_variables || 0} variables
              </Badge>
            </div>
          </div>
          <div className="flex-shrink-0">
            <Button
              size="sm"
              variant="destructive"
              onClick={() => onEliminar?.(p.id)}
            >
              <Trash2 className="h-3 w-3" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
